import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Button, Divider, Grid, Image, Text
} from 'components/ui';
import Modal from 'components/Modal/Modal';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import BiRewardsSamplesModalEN from 'components/GlobalModals/BiRewardsModal/locales/BiRewardsModal_en_US';
import BiRewardsSamplesModalFR from 'components/GlobalModals/BiRewardsModal/locales/BiRewardsModal_fr_CA';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import ProductList from 'components/Content/ProductList';
import userUtils from 'utils/User';
import biProfileUtils from 'utils/BiProfile';
import auth from 'utils/Authentication';
import contentConstants from 'constants/content';
import stringUtils from 'utils/String';
import AddToBasketButton from 'components/AddToBasketButton';
import anaConsts from '../../../analytics/constants';
import ADD_BUTTON_TYPE from 'utils/Basket';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import * as RwdBasketConstants from 'constants/RwdBasket';
import Empty from 'constants/empty';
import RewardFulfillmentMethodModal from 'components/RewardFulfillmentMethodModal';
import { HEADER_VALUE } from 'constants/authentication';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const { REWARD_GROUPS } = biProfileUtils;
const { CONTEXTS, PRODUCT_LIST_GROUPING, PRODUCT_LIST_VARIANTS } = contentConstants;
const { capitalize } = stringUtils;
const getText = getLocalisedDataFromResource(BiRewardsSamplesModalEN, BiRewardsSamplesModalFR);
const BI_TYPES = userUtils.types;

function BiRewardsModal(props) {
    const {
        isOpen,
        openBiRewardsModal,
        setFromBazaar,
        fetchBiRewards,
        showErrorMessage,
        isAnonymous,
        source,
        analyticsData,
        additionalArguments = {},
        basket,
        biAccount,
        availableRewards,
        showRewardFulfillmentMethodModal
    } = props;

    // eslint-disable-next-line  object-curly-newline
    const [basketType, setBasketType] = useState(null);

    useEffect(() => {
        setFromBazaar(true);

        const loadRewards = async () => {
            try {
                await fetchBiRewards();
                // TODO: if items length undefined or items null then hide? since there is not api call for rewards list - it is pre-appended in header of page - contentful.
                // if (samplesDetails?.samples?.length === 0) {
                //     openBiRewardsModal(false);
                //     showErrorMessage();
                // }
            } catch (e) {
                openBiRewardsModal(false);
                showErrorMessage();
                Sephora.logger.error('fetchBiRewards failed', e);
            }
        };

        loadRewards();

        const storedBasketType = Storage.local.getItem(LOCAL_STORAGE.BASKET_TYPE);
        setBasketType(storedBasketType);

        return () => {
            setFromBazaar(false);
        };
    }, [setFromBazaar, fetchBiRewards, showErrorMessage, openBiRewardsModal]);

    const close = () => {
        openBiRewardsModal(false);
    };

    const signInHandler = analyticsContext => {
        return e => {
            e.preventDefault();

            digitalData.page.attributes.previousPageData.linkData = 'rewards bazaar:sign in';

            auth.requireAuthentication(
                null,
                null,
                {
                    context: analyticsContext,
                    nextPageContext: analyticsContext
                },
                null,
                false,
                HEADER_VALUE.USER_CLICK
            ).catch(() => {});
        };
    };

    const getPersonalizedInternalCampaign = rewardsGroup => {
        let personalizedInternalCampaign;

        if (
            source === RwdBasketConstants.TOP_BANNER_PERSONALIZED_MESSAGES.BIRTHDAY_GIFT &&
            rewardsGroup === REWARD_GROUPS.BIRTHDAY &&
            analyticsData?.personalizedInternalCampaign
        ) {
            personalizedInternalCampaign = analyticsData.personalizedInternalCampaign;
        }

        return personalizedInternalCampaign;
    };

    const renderBiButton = rewardsGroup => {
        const { replaceProduct, skuToReplace = Empty.Object } = additionalArguments;

        return ({ analyticsContext, sku }) => {
            return (
                <>
                    <Box
                        marginTop='auto'
                        paddingTop={3}
                    >
                        {isAnonymous ? (
                            <Button
                                variant='secondary'
                                size='sm'
                                onClick={signInHandler(analyticsContext)}
                            >
                                {getText('signInToAccess')}
                            </Button>
                        ) : (
                            <AddToBasketButton
                                isRewardItem
                                analyticsContext={analyticsContext || anaConsts.CONTEXT.BASKET_REWARDS}
                                variant={ADD_BUTTON_TYPE.SECONDARY}
                                isAddButton={true}
                                size='sm'
                                sku={sku}
                                isBIRBReward={true}
                                containerTitle={anaConsts.CAROUSEL_NAMES.REWARD_BAZAAR}
                                personalizedInternalCampaign={getPersonalizedInternalCampaign(rewardsGroup)}
                                basketType={basketType}
                                {...(replaceProduct &&
                                    skuToReplace?.skuId && {
                                    replaceProduct,
                                    skuToReplace,
                                    productIdToReplace: sku.productId
                                })}
                            />
                        )}
                    </Box>
                </>
            );
        };
    };

    const renderRewards = (rewards, birthdayRewardDaysLeft) => {
        const { skuToReplace = Empty.Object } = additionalArguments;

        const allRewards = [];
        const birthdayRewardDaysLeftText = birthdayRewardDaysLeft
            ? getText('daysToRedeem', [birthdayRewardDaysLeft])
            : getText('lastChanceRedeemToday');

        Object.entries(rewards?.biRewardGroups || []).forEach(([key, value], index) => {
            const skusUpdated = rougeExclusiveUtils.updateRougeExclusiveSkus(value, basket);

            // TODO: Remove selected SKU from list
            // skusUpdated = skusUpdated.filter(item => item.skuId !== skuToReplace?.skuId);

            allRewards.push(
                <>
                    {index !== 0 && <Divider />}
                    {skusUpdated ? (
                        <ProductList
                            skuList={skusUpdated}
                            sid={'rewards_bazaar_rewards'}
                            title={key === REWARD_GROUPS.BIRTHDAY ? getText('chooseBirthdayGift') : key}
                            anchor={key.replace(/\s/g, '').toLowerCase()}
                            marginTop={index === 0 ? 0 : 4}
                            marginBottom={5}
                            page={'basket'}
                            variant={PRODUCT_LIST_VARIANTS.SMALL_CAROUSEL}
                            context={CONTEXTS.MODAL}
                            isBIRBReward={true}
                            titleMarginBottom={[3, 4]}
                            isShortButton={true}
                            renderBiButton={renderBiButton(key)}
                            grouping={[
                                PRODUCT_LIST_GROUPING.SHOW_ADD_BUTTON,
                                PRODUCT_LIST_GROUPING.SHOW_PRICE,
                                PRODUCT_LIST_GROUPING.SHOW_MARKETING_FLAGS
                            ]}
                            isBirthDayRewardList={key === REWARD_GROUPS.BIRTHDAY}
                            secondSubtitle={{ inner: birthdayRewardDaysLeftText }}
                            showQuickLookOnMobile={true}
                            subtitle={
                                key === REWARD_GROUPS.BIRTHDAY ? getText('birthdayMessage', [capitalize(userUtils.getProfileFirstName())]) : null
                            }
                            rougeBadgeText={getText('rougeBadge')}
                            {...skusUpdated}
                            {...(skuToReplace?.skuId && { skuToReplace })}
                        />
                    ) : null}
                </>
            );
        });

        return <Box>{allRewards}</Box>;
    };

    const { biPoints, biStatus, birthdayRewardDaysLeft } = biAccount;
    const biStatusIcon = userUtils.displayBiStatus(biStatus.toUpperCase());
    const statusText = biStatus === BI_TYPES.BI.toLowerCase() ? 'biPointsInsiderText' : 'biPointsText';

    return (
        <>
            <Modal
                showDismiss={true}
                width={866}
                hasBodyScroll={true}
                isOpen={isOpen}
                isHidden={showRewardFulfillmentMethodModal}
                onDismiss={close}
            >
                <Modal.Header>
                    <Modal.Title children={getText('title')} />
                    <Divider
                        marginY={4}
                        marginX={'-44px'}
                    />
                    <Text
                        display='block'
                        is='p'
                        textAlign='left'
                        marginLeft={['-21px', '-29px']}
                    >
                        {`${getText(statusText)} `}
                        <Image
                            src={`/img/ufe/bi/logo-${biStatusIcon.toLowerCase()}.svg`}
                            alt={biStatusIcon}
                            height='.725em'
                        />
                        {` ${getText('with')} `}
                        <strong>{biPoints.toLocaleString('en-US')}</strong> {getText('points')}
                    </Text>
                </Modal.Header>
                <Modal.Body>{availableRewards?.rewards && renderRewards(availableRewards.rewards, birthdayRewardDaysLeft)}</Modal.Body>
                <Modal.Footer css={{ paddingBottom: '8px' }}>
                    <Grid justifyContent={['center', 'end']}>
                        <Button
                            variant='primary'
                            width={['97vw', 235]}
                            block={true}
                            onClick={close}
                            children={getText('done')}
                        />
                    </Grid>
                </Modal.Footer>
            </Modal>
            {showRewardFulfillmentMethodModal && <RewardFulfillmentMethodModal />}
        </>
    );
}

export default wrapFunctionalComponent(BiRewardsModal, 'BiRewardsModal');
